import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import {
  pageheaderAddPath,
  PageheaderAddUrlQueryParams,
  pageheaderListPath,
  PageheaderListUrlQueryParams,
  PageheaderListUrlSortField,
  pageheaderPath,
  PageheaderUrlQueryParams
} from "./urls";
import PageheaderCreateComponent from "./views/PageheaderCreate";
import PageheaderDetailsComponent from "./views/PageheaderDetails";
import PageheaderListComponent from "./views/PageheaderList";

const PageheaderList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: PageheaderListUrlQueryParams = asSortParams(
    qs,
    PageheaderListUrlSortField
  );
  return <PageheaderListComponent params={params} />;
};

const PageheaderCreate: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: PageheaderAddUrlQueryParams = qs;
  return <PageheaderCreateComponent params={params} />;
};

const PageheaderDetails: React.FC<RouteComponentProps<{ id: string }>> = ({
  location,
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: PageheaderUrlQueryParams = qs;
  return (
    <PageheaderDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

export const PageheaderSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.pageheaders)} />
      <Switch>
        <Route exact path={pageheaderListPath} component={PageheaderList} />
        <Route exact path={pageheaderAddPath} component={PageheaderCreate} />
        <Route path={pageheaderPath(":id")} component={PageheaderDetails} />
      </Switch>
    </>
  );
};

export default PageheaderSection;
